// responsive screen size  
$(document).ready(function() {
    checkWidth();
});
$(window).on("resize", function(){
    checkWidth();
});


function checkWidth(){
    $vWidth = $(window).width();
    
    //Check condition for screen width
    if($vWidth <= 767) {
      
    //   mobile responsive
  
      (function($) {

        $('.index .image-with-text').each(function() {
          $( this ).find('.image-with-text__image-column .image-element__wrap').insertAfter($( this ).find('.image-with-text__wrapper >span.image-with-text__heading'));
        });

      })(jQuery);
      
      (function($) {

        $('.page-sanbera_values .block__image-with-text').each(function() {
          $( this ).find('.image-with-text__image-column .image-element__wrap').insertAfter($( this ).find('.image-with-text__wrapper >span.image-with-text__preheading'));
        });

      })(jQuery);
      
    }else{
      
      (function($) {

        $('.index .image-with-text, .page-sanbera_values .block__image-with-text').each(function() {
          $( this ).find('.image-element__wrap').appendTo($( this ).find('.image-with-text__image-column'));
        });

      })(jQuery);
      
    }
}